(() => {
  if (window.vuuSizeGuideInitialized) return;
  window.vuuSizeGuideInitialized = true;
  const openers = new WeakMap();
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-vuu-size-open]');
    if (open) {
      const dialog = document.getElementById(open.getAttribute('aria-controls'));
      if (dialog && !dialog.open) {
        openers.set(dialog, open);
        dialog.showModal();
      }
      return;
    }
    const close = event.target.closest('[data-vuu-size-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('dialog.vuu-size-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches('dialog.vuu-size-dialog')) openers.get(event.target)?.focus({ preventScroll: true });
  }, true);
})();
